import React from 'react'
import { css } from 'aphrodite'
import { Col, Row } from 'reactstrap'
import { Link } from 'react-router-dom'

import pathRegexp from 'path-to-regexp'

import access from '../../../../utils/access'

import style from './style'

const privateRouteList = [
  {
    title: 'Story View',
    path: `/:seo`
  },
  {
    title: 'Edit Story',
    path: `/:seo/edit`,
    access: access.modBlog
  }
]

const routeList = [
  {
    title: `Home`,
    path: ``
  },
  {
    title: `New Story`,
    path: `new`,
    access: access.modBlog
  }
]

export const Sidebar = props => {
  return (
    <Row>
      <Col>
        <Row>
          <Col>
            {props.hide ? null : (
              <Row className={css(style.navigation.wrapper)}>
                <Col className={css(style.navigation.innerWrapper)}>
                  {privateRouteList.map((route, index) => {
                    if (
                      route.access &&
                      (!props.permissions || !route.access(props.permissions))
                    ) {
                      return null
                    }

                    return (
                      <RenderLink
                        key={`${route.title}_${index}`}
                        title={route.title}
                        path={route.path}
                        currentPath={props.location.pathname}
                        match={props.match}
                      />
                    )
                  })}
                </Col>
              </Row>
            )}
          </Col>
        </Row>
        <Row>
          <Col>
            {props.hide ? null : (
              <Row className={css(style.navigation.wrapper)}>
                <Col className={css(style.navigation.innerWrapper)}>
                  {routeList.map((route, index) => {
                    if (
                      route.access &&
                      (!props.permissions || !route.access(props.permissions))
                    ) {
                      return null
                    }

                    return (
                      <RenderLink
                        key={`${route.title}_${index}`}
                        title={route.title}
                        path={route.path}
                        currentPath={props.location.pathname}
                        match={props.match}
                      />
                    )
                  })}
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

const RenderLink = props => {
  const path = Object.keys(props.match.params).reduce(
    (_url, key) => _url.replace(`:${key}`, props.match.params[key]),
    `/dashboard/news${props.path.length > 0 ? `/${props.path}` : ``}`.replace(
      '//',
      '/'
    )
  )

  if (path.includes(':')) {
    return null
  }

  return (
    <Row>
      <Col className={css(style.navigation.row)}>
        <Link
          to={path}
          className={css(
            style.navigation.link,
            pathRegexp(path).exec(props.currentPath)
              ? style.navigation.activeLink
              : null
          )}
        >
          {props.title}
        </Link>
      </Col>
    </Row>
  )
}

export default Sidebar



// WEBPACK FOOTER //
// ./src/components/News/partials/Sidebar/index.js